(function () {
  function colourFromAlt(alt, valid) {
    if (!alt) return null;
    var parts = String(alt).split(' - ');
    if (parts.length < 2) return null;
    var tail = parts[parts.length - 1].trim();
    if (!tail || tail.length > 40) return null;
    if (valid && valid.length && valid.indexOf(tail) === -1) return null;
    return tail;
  }

  function colourValues() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return [];
    var vals = [];
    var radios = picker.querySelectorAll('input[type=radio]');
    for (var i = 0; i < radios.length; i++) {
      if (/colou?r/i.test(radios[i].name || '')) {
        var v = radios[i].value;
        if (v && vals.indexOf(v) === -1) vals.push(v);
      }
    }
    var select = picker.querySelector('select');
    if (!vals.length && select && /colou?r/i.test(select.name || '')) {
      for (var j = 0; j < select.options.length; j++) {
        var ov = select.options[j].value;
        if (ov && vals.indexOf(ov) === -1) vals.push(ov);
      }
    }
    return vals;
  }

  function currentColour() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return null;
    var radios = picker.querySelectorAll('input[type=radio]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (/colou?r/i.test(radios[i].name || '')) return radios[i].value;
    }
    var selects = picker.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      if (/colou?r/i.test(selects[j].name || '') || /colou?r/i.test(selects[j].getAttribute('aria-label') || '')) return selects[j].value;
    }
    return null;
  }

  var applying = false;

  function apply() {
    if (applying) return;
    var current = currentColour();
    var items = document.querySelectorAll('media-gallery li.product-media-container, media-gallery slideshow-slide');
    if (!items.length || !current) return;

    var tagged = 0;
    var valid = colourValues();
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      var c = colourFromAlt(img && img.alt, valid);
      if (c) tagged++;
      items[i].__veltraColour = c;
    }
    if (!tagged) return;

    applying = true;
    for (var k = 0; k < items.length; k++) {
      var it = items[k];
      var hide = it.__veltraColour && it.__veltraColour !== current;
      if (hide) {
        if (!it.classList.contains('veltra-colour-hidden')) it.classList.add('veltra-colour-hidden');
      } else if (it.classList.contains('veltra-colour-hidden')) {
        it.classList.remove('veltra-colour-hidden');
      }
    }
    applying = false;
    document.documentElement.setAttribute('data-veltra-colour', current);
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }

  document.addEventListener('change', schedule, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker, label, input, select')) schedule();
  }, true);

  function watch() {
    var gallery = document.querySelector('media-gallery');
    if (gallery && window.MutationObserver) {
      new MutationObserver(schedule).observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt', 'src'] });
    }
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(watch, 250); });
  else setTimeout(watch, 250);

  [500, 1200, 2500, 4000].forEach(function (ms) { setTimeout(apply, ms); });
  setInterval(apply, 900);
})();
